import { RootState } from "../../../../../redux/store";

export const isItemsLoading = (state:RootState) => state.articlePackTypes.itemsLoading;
export const isItemActionLoading = (state:RootState) => state.articlePackTypes.actionsLoading;
export const getItems = (state:RootState) => state.articlePackTypes.items;
export const getItemsSelect = (state:RootState) => state.articlePackTypes.dropDownItems;
export const getItemsCount = (state:RootState) => state.articlePackTypes.itemsCount;
export const getItemForEdit = (state:RootState) => state.articlePackTypes.itemForEdit;
export const getError = (state:RootState) => state.articlePackTypes.error;
export const getErrorAction = (state:RootState) => state.articlePackTypes.errorAction;
export const validationErrors = (state: RootState) => state.articlePackTypes.validationErrors;
